import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'go_to_face_details';
export const useGoToFaceDetailsTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Детали лица',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Face details',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Detalhes da face',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Detalles de la cara',
  },
}) as Record<string, unknown>;
